import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import FullPageLoader, { ActivateForAnyLoad, } from "../../_common/loaders/FullPageLoader";
import TopBar from "./top-bar/TopBar";
import { Outlet, useOutletContext } from "react-router";
export default function AuthenticatedFrame() {
    const authFrameContext = useOutletContext();
    return (_jsxs(FullPageLoader, { loadingActions: ActivateForAnyLoad, children: [_jsx(TopBar, {}), _jsx(Outlet, { context: authFrameContext })] }));
}
